// Placeholder origin used only to parse the param; any absolute or
// protocol-relative URL resolves to a different origin and is rejected.
const PARSE_BASE = 'https://app.invalid';

/**
 * The `_auth` guard sends signed-out visitors to `/login?redirect=<href>` so they
 * can land back on the page they were on after signing in. Only a same-origin
 * app path is honored — never another site (open redirect) or /login itself
 * (redirect loop). Returns the path + query + hash to navigate to, or null.
 */
export function getSafeLoginRedirect(redirect: string | undefined): string | null {
  if (!redirect || !redirect.startsWith('/')) return null;

  let url: URL;
  try {
    url = new URL(redirect, PARSE_BASE);
  } catch {
    return null;
  }

  if (url.origin !== PARSE_BASE) return null;
  if (url.pathname === '/login' || url.pathname.startsWith('/login/')) return null;

  return `${url.pathname}${url.search}${url.hash}`;
}
